<div class="flex flex-wrap gap-2 items-center">
  <ng-container *ngFor="let option of options">
    <button type="button"
            class="px-3 py-1 text-sm rounded-md border transition-colors font-medium flex items-center gap-2"
            [class]="getButtonClasses(option)"
            (click)="toggleOption(option)">
      <i *ngIf="option.icon" [class]="option.icon"></i>
      {{ option.label | translate }}
    </button>
  </ng-container>

  <button type="button"
          class="group relative w-10 h-10 bg-gray-500 hover:bg-gray-800 text-gray-100 rounded-full border border-gray-300 transition-colors"
          (click)="clearAll()">

    <i class="fa-solid fa-xmark text-lg"></i>

    <span class="absolute left-1/2 -translate-x-1/2 -top-3 -translate-y-full
               px-2 py-1 text-xs text-white bg-black rounded opacity-0
               group-hover:opacity-100 transition pointer-events-none">
      {{ 'clear' | translate }} {{ 'filters' | translate }}
    </span>
    <span class="absolute left-1/2 -translate-x-1/2 -top-3
               w-0 h-0 border-4 border-transparent border-t-black
               opacity-0 group-hover:opacity-100 transition pointer-events-none"></span>
  </button>
</div>
